import PropTypes from 'prop-types';
import { Col, OverlayTrigger, Tooltip, Stack } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { PlatformRow } from './platformRow';
import { useLocales } from '../../../../locales';
import { overallDevelopmentCardConfig } from '../../../../config/analytics/analyticsCardsConfig';
import IsLoadingIndicator from '../../../isLoadingIndicator';

export function OverallDevelopmentListCard({ data, error }) {
  const { translate: t } = useLocales();
  if (error)
    return (
      <div className="card rounded p-4 container  shadow h-100 justify-content-center align-items-center">
        <span className="text-muted">
          {t('overallCard.data_cant_be_loaded')}
        </span>
      </div>
    );
  if (!data) {
    return (
      <div className="card rounded p-4 container  shadow h-100 justify-content-center align-items-center">
        <IsLoadingIndicator />
      </div>
    );
  }

  return (
    <div className="card rounded p-4 container h-100 shadow">
      <div className="d-flex align-items-center justify-content-between text-align-center">
        <h3 className="" style={{ fontWeight: 500, fontSize: '1.275rem' }}>
          {t('insights')}
        </h3>
        <div className="d-flex">
          <div>
            <p className=" m-0 p-0 me-2 fw-bold text-muted">
              {t('analyticsCards.last_30_days')}
            </p>
          </div>
          <div className="text-muted me-4">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>{t('overallCard.info_icon')}</Tooltip>}
            >
              <i className="fa-duotone fa-circle-info fa-sm"></i>
            </OverlayTrigger>
          </div>
        </div>
      </div>
      <Stack className="justify-content-between h-100 pb-4">
        <Col xs={12} className="p-2 h-100 d-flex w-100">
          <div
            className={'w-100'}
            style={{ flexWrap: 'wrap', overflow: 'scroll', maxHeight: '100%' }}
          >
            {Object.keys(overallDevelopmentCardConfig).map((plotName) => {
              if (!data?.[overallDevelopmentCardConfig?.[plotName]?.key])
                return null;
              //                ||data?.[overallDevelopmentCardConfig[plotName]?.key]?.data?.length === 0) return null;
              return (
                <PlatformRow
                  key={plotName}
                  metricConfig={overallDevelopmentCardConfig[plotName]}
                  data={data?.[plotName]}
                  info_text={overallDevelopmentCardConfig[plotName]?.info_text}
                />
              );
            })}
          </div>
        </Col>
      </Stack>
    </div>
  );
}

OverallDevelopmentListCard.propTypes = {
  data: PropTypes.any,
  error: PropTypes.bool
};
